import React, {useState}  from 'react';
import bluearrow from '../images/blue_arrow.svg';
import whitearrow from '../images/white_arrow.svg';
import { getLobby } from './helpers/apihandler';
import { LobbyDetails } from './lobbyDetails';

function Lobby({weeks, walletAddress}){
const [styleDisplay, setStyleDisplay] = useState([]);
const [weeklyLobby, setWeeklyLobby] = useState([]);
    const weekData = weeks;

    const showOrHide = async(x, id) => {
        if (styleDisplay[x] === "none" || styleDisplay[x] === undefined){
            let templobby = [...weeklyLobby];
            if (templobby[id] === undefined ){
                let tempcurrentlb = await getLobby(id);
                templobby[id] = tempcurrentlb;
            }
            setWeeklyLobby(templobby);
            let tempstyle = [...styleDisplay];
            tempstyle[x] = "flex";
            setStyleDisplay(tempstyle);
        }else{
            let tempstyle = [...styleDisplay];
            tempstyle[x] = "none";
            setStyleDisplay(tempstyle);
        }
    }

    return <div><div className='createFormat row'><div className='col-md-4' style={{fontWeight:'bold', fontSize:'1.1em'}}>Week #:</div><div className='col'>Show / Hide</div><div className='col-md-4' style={{fontWeight:'bold', fontSize:'1.1em'}}>Event Type:</div></div>{weekData.map( function(week, i) {
       return <div key={i} id={'coll' + i.toString()} className='row' style={{paddingLeft:'3%'}} ><div className='col-md-4' style={{fontWeight:'bold', backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} >{week.id}</div><div style={{fontWeight:'bold', display:'inline', backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} className='col'><img src={(styleDisplay[i] !== 'flex' ? bluearrow : whitearrow)} onClick={() => {showOrHide(i, week.id)}} alt="showhide" style={{width:'16px',cursor:'pointer'}} /></div> <div className='col-md-4' style={{ backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} >{week.racename}</div><div><LobbyDetails details={weeklyLobby[week.id]} racetype={week.racetype} styledisplay={styleDisplay[i]} weeknum={week.id} walletAddress={walletAddress} /></div></div>
        
    })}</div>
}

export {Lobby};